import { render } from "./ExplanationDialog.vue?vue&type=template&id=fd647b8a"
import script from "./ExplanationDialog.vue?vue&type=script&lang=js"
export * from "./ExplanationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__